var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('object-grid',{attrs:{"value":_vm.managers,"title":"Менеджеры","field-defs":[
      { text: 'ФИО' },
      { text: 'E-Mail' },
      { text: 'Количество клиентов' },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }